// extracted by mini-css-extract-plugin
export default {"burgerList":"burger_burgerList__M7swg","ingredientsList":"burger_ingredientsList__PNCDr"};